// Copyright 2025, University of Maryland, All Rights Reserved
import { axiosInstance } from './client';
import type {
  BulkAnalysisRequest,
  BulkAnalysisResponse,
  BulkAnalysisJobStatus,
  BulkAnalysisRecord,
  BulkComparisonRequest,
  BulkComparisonResponse,
  UnifiedAnalysisRequest,
  UnifiedAnalysisResponse,
  UnifiedAnalysisJobStatus
} from './types';

export const bulkOperationsApi = {
  // Bulk Analysis operations
  async startBulkAnalysis(request: BulkAnalysisRequest): Promise<BulkAnalysisResponse> {
    const response = await axiosInstance.post('/documents/bulk-analyze', request, {

    });
    return response.data;
  },

  async getBulkAnalysisStatus(bulkAnalysisId: string): Promise<BulkAnalysisJobStatus> {
    const response = await axiosInstance.get(`/documents/bulk-analysis/${bulkAnalysisId}`, {

    });
    return response.data;
  },

  async listBulkAnalyses(status?: string): Promise<BulkAnalysisRecord[]> {
    const params: any = {};
    if (status) {
      params.status = status;
    }

    const response = await axiosInstance.get('/documents/bulk-analysis/', {
      params
    });
    return response.data.bulk_analyses;
  },

  async deleteBulkAnalysis(bulkAnalysisId: string): Promise<void> {
    await axiosInstance.delete(`/documents/bulk-analysis/${bulkAnalysisId}`, {

    });
  },

  // Bulk Comparison operations
  async getBulkComparisons(): Promise<any> {
    const response = await axiosInstance.get('/documents/bulk-compare/', {

    });
    return response.data;
  },

  async startBulkComparison(request: BulkComparisonRequest): Promise<BulkComparisonResponse> {
    const response = await axiosInstance.post('/documents/bulk-compare', request, {

    });
    return response.data;
  },

  async getBulkComparisonStatus(comparisonId: string): Promise<any> {
    const response = await axiosInstance.get(`/documents/bulk-compare/${comparisonId}`, {

    });
    return response.data;
  },

  // Unified Analysis operations
  async startUnifiedAnalysis(request: UnifiedAnalysisRequest): Promise<UnifiedAnalysisResponse> {
    const response = await axiosInstance.post('/documents/unified-analyze', request, {

    });
    return response.data;
  },

  async getUnifiedAnalysisStatus(unifiedAnalysisId: string): Promise<UnifiedAnalysisJobStatus> {
    const response = await axiosInstance.get(`/documents/unified-analysis/${unifiedAnalysisId}`, {
      
    });
    return response.data;
  }
};